import { Typography } from '@mui/material';
import { Box } from '@mui/material';
import { Styles } from '@t2c/shared-fe';
import { Button } from '@mui/material';
import { useRouter } from 'next/router';
import { handleDownloadVideoFile } from 'apps/t2c-fe/utils';
import { useGetAllCreatedAudios } from 'apps/t2c-fe/hooks/audios';
import { CreatedAudiosSection } from './CreatedAudiosSection';
import { TextToSpeechCard } from './TextToSpeechCard';
import { useGetAudioBuildById } from 'apps/t2c-fe/services/audio/getAudioBuildById';

export const TextToSpeechPreviewPage = () => {
  const { query, push } = useRouter();
  const audioId = query?.id as string;
  const { data: dataById, refetch: refetchById } = useGetAudioBuildById({ id: audioId });
  const handleGenerateNew = () => {
    push('/text-to-audio');
  };

  const {
    data: createdTextToSpeechData,
    refetch: refetchTextToSpeechData,
    isLoading: isFetchingTextToSpeechData,
  } = useGetAllCreatedAudios({
    limit: 4,
    sortOrder: 'desc',
    sortBy: 'updatedAt',
  });

  const refetch = () => {
    refetchTextToSpeechData();
    refetchById();
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.previewContainer}>
        <Typography fontSize={24} fontWeight={500}>
          Audio-Voiceover
        </Typography>
        <Box sx={styles.name}>
          <Typography sx={styles.text}>{dataById?.name}</Typography>
        </Box>
        <Box sx={{ width: {xs: '100%', md :'50%'}, alignSelf: 'center' }}>
          <TextToSpeechCard data={dataById} menuActions={[]} isHideName={true} />
        </Box>
        <Box sx={styles.btns}>
          <Button
            variant="outlined"
            sx={{
              flex: 1,
              boxShadow: 'none',
              color: (theme) => theme.palette.common.white,
              backgroundColor: (theme) => theme.palette.background.secondary,
              borderColor: (theme) => theme.palette.background.border,
            }}
            onClick={handleGenerateNew}
          >
            Create New Audio Voiceover
          </Button>
          <Button
            variant="contained"
            sx={{ flex: 1, boxShadow: 'none', color: (theme) => theme.palette.text.primary }}
            onClick={() =>
              handleDownloadVideoFile({
                name: dataById?.name,
                url: dataById?.processedURL,
                format: 'audio',
              })
            }
          >
            Download
          </Button>
        </Box>
      </Box>
      <Box sx={styles.clipsSection}>
        <CreatedAudiosSection
          isDataLoading={isFetchingTextToSpeechData}
          data={createdTextToSpeechData}
          refetchTextToSpeechData={refetch}
          allAudios={false}
        />
      </Box>
    </Box>
  );
};

const styles: Styles = {
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  previewContainer: {
    backgroundColor: (theme) => theme.palette.background.primary,
    borderColor: (theme) => theme.palette.background.border,
    // height: '100%',
    display: 'flex',
    flexDirection: 'column',
    width: '95%',
    gap: '32px',
    borderRadius: '16px',
    borderWidth: '3px',
    padding: '32px',
  },
  clipsSection: {
    width: '95%',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  btns: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    width: '100%',
    gap: 2,
  },
  name: {
    p: 2,
    backgroundColor: (theme) => theme.palette.background.activeCard,
    alignItems: 'center',
    borderRadius: '4px',
    alignSelf: 'center',
  },
  text: {
    color: (theme) => theme.palette.text.primary,
  },
};
